module.exports = __webpack_public_path__ + "img/smartphone.b9876069.svg";